import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import {
  Transition,
  Container,
  Segment,
  Label,
  Header,
  Message,
  Icon,
  Divider,
  Button
} from "semantic-ui-react";
import BotonCerrar from "../shared/botones/BotonCerrar";
import { preinscripcionesOps } from "../../ducks/preinscripciones";
import { documentacionOps } from "../../ducks/documentacion";
import FormularioInscripcion from "./hojaPreinscripcion/FormularioInscripcion";
import isEmpty from "lodash/isEmpty";
import { Object } from "core-js";
import DocumentUploader from "../adjuntarDocumentacion/DocumentUploader";
import Adjunto from "./hojaPreinscripcion/Adjunto";

class HojaPreinscripcion extends React.Component {
  state = {
    idColegio: null,
    idInscripcion: null,
    showMessage: this.props.dataSaved.status,
    saveMessage: this.props.dataSaved.message,
    colorMessage: "pink",
    iconMessage: "check",
    sizeMessage: "big",
    redirect: false,
    redirectTo: null,
    showFileUploader: false
  };

  componentDidMount() {
    const {
      match: {
        params: { idColegio, idInscripcion }
      }
    } = this.props;
    this.setState({ idColegio, idInscripcion });
    this.props.obtenerDatosPreinscripcion({
      idColegio,
      idInscripcion
    });
    this.props.obtenerDatosColegio(idColegio);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      showMessage: nextProps.dataSaved.status,
      saveMessage: nextProps.dataSaved.message,
      resguardo: nextProps.dataSaved.resguardo
    });

    nextProps.dataSaved.status &&
      setTimeout(() => {
        this.props.resetSavedData();
        nextProps.dataSaved.message === "Se ha confirmado la preinscripción" &&
          this.setState(state => ({
            redirect: true,
            redirectTo: (
              <Redirect
                to={`/inscripciones-confirmadas/${state.idColegio}/${
                  state.idInscripcion
                }`}
              />
            )
          }));
      }, 2000);
  }

  componentWillUnmount() {
    this.props.limpiarDatosPreinscripcion();
    this.props.limpiarDatosColegio();
    this.setState({
      showMessage: false,
      saveMessage: "",
      resguardo: null
    });

    const {
      match: {
        params: { idColegio, idInscripcion }
      }
    } = this.props;

    this.props.detachDatosPreinscripcion({ idColegio, idInscripcion });
  }

  handleGuardarInscripcion = values =>
    this.props.guardarCambiosInscripcion({
      values,
      idColegio: this.state.idColegio,
      idInscripcion: this.state.idInscripcion
    });

  handleConfirmarInscripcion = ({ resguardo, formaDePago }) =>
    this.props.confirmarInscripcion({
      idColegio: this.props.match.params.idColegio,
      idInscripcion: resguardo,
      formaDePago
    });

  handleShowFileUploader = () =>
    this.setState(state => ({
      showFileUploader: !state.showFileUploader
    }));

  handleUploadFile = file => {
    this.props.clearUploadComplete();
    this.props.uploadFile({
      file,
      resguardo: this.props.match.params.idInscripcion,
      idColegio: this.props.match.params.idColegio
    });

    setTimeout(() => this.props.clearUploadComplete(), 1000);
  };

  handleBorrarAdjunto = data =>
    this.props.borrarAdjunto({
      ...data,
      idColegio: this.state.idColegio,
      idInscripcion: this.state.idInscripcion
    });

  renderAdjuntos = () => {
    const { adjuntos } = this.props.datosPreinscripcion;
    const rutas = adjuntos ? Object.values(adjuntos) : [];
    const ids = adjuntos ? Object.keys(adjuntos) : [];

    return rutas.map((ruta, index) => (
      <Adjunto
        key={ids[index]}
        id={ids[index]}
        url={ruta.url}
        fileName={ruta.fileName}
        handleBorrarAdjunto={this.handleBorrarAdjunto}
      />
    ));
  };

  render() {
    const {
      match: { params },
      datosPreinscripcion
    } = this.props;
    const { redirect, redirectTo } = this.state;
    return redirect ? (
      redirectTo
    ) : (
      <Transition.Group animation="scale" duration={150}>
        {!isEmpty(datosPreinscripcion) && (
          <Container>
            <Transition.Group animation="fly down" duration={500}>
              {this.state.showMessage && (
                <Segment
                  basic
                  style={{
                    left: "40%",
                    position: "fixed",
                    top: "15%",
                    zIndex: 1000
                  }}
                >
                  <Message
                    size={this.state.sizeMessage}
                    color={this.state.colorMessage}
                  >
                    {this.state.saveMessage}
                    <Icon name={this.state.iconMessage} />
                  </Message>
                </Segment>
              )}
            </Transition.Group>

            <Segment basic>
              <BotonCerrar
                floated="right"
                linkTo={`/preinscripciones/${params.idColegio}`}
              />
              <BotonCerrar
                floated="right"
                linkTo="/escuelas/listados"
                buttonText="Inicio"
              />

              <Header inverted as="h3">
                {`Hoja de Preinscripción del Colegio ${
                  this.props.datosColegio.nombre
                }`}
              </Header>
            </Segment>

            <Segment>
              <Label
                basic
                size="big"
                content="Nº Resguardo:"
                detail={params.idInscripcion}
              />
              <Divider />
              <Header as="h3" content="Ficheros Adjuntos" />
              <Button
                color="pink"
                content={
                  this.state.showFileUploader ? "Ocultar" : "Adjuntar Fichero"
                }
                icon="add"
                onClick={this.handleShowFileUploader}
              />

              {this.state.showFileUploader && (
                <DocumentUploader
                  handleUploadFile={this.handleUploadFile}
                  procesoEnvio={this.props.procesoEnvio}
                  uploadComplete={this.props.uploadComplete}
                />
              )}
              <Divider />

              {this.renderAdjuntos()}
              <Divider />

              <FormularioInscripcion
                initialValues={this.props.datosPreinscripcion}
                guardarCambios={this.handleGuardarInscripcion}
                confirmar={this.handleConfirmarInscripcion}
                precios={this.props.datosColegio.precios}
                provincia={this.props.datosColegio.provincia}
              />
            </Segment>
          </Container>
        )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = state => ({
  datosPreinscripcion: state.preinscripciones.datosPreinscripcion,
  datosColegio: state.preinscripciones.datosColegio,
  dataSaved: state.preinscripciones.dataSaved,
  uploadComplete: state.documentacion.uploadComplete,
  procesoEnvio: state.documentacion.procesoEnvio
});

const mapDispatchToProps = {
  obtenerDatosColegio: preinscripcionesOps.obtenerDatosColegio,
  limpiarDatosColegio: preinscripcionesOps.limpiarDatosColegio,
  obtenerDatosPreinscripcion: preinscripcionesOps.obtenerDatosPreinscripcion,
  limpiarDatosPreinscripcion: preinscripcionesOps.limpiarDatosPreinscripcion,
  confirmarInscripcion: preinscripcionesOps.confirmarInscripcion,
  guardarCambiosInscripcion: preinscripcionesOps.guardarCambiosInscripcion,
  resetSavedData: preinscripcionesOps.resetSavedData,
  clearUploadComplete: documentacionOps.clearUploadComplete,
  uploadFile: documentacionOps.uploadFile,
  borrarAdjunto: documentacionOps.borrarAdjunto,
  detachDatosPreinscripcion: preinscripcionesOps.detachDatosPreinscripcion
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HojaPreinscripcion);



// WEBPACK FOOTER //
// ./src/pages/preinscripciones/HojaPreinscripcion.jsx